export const removeFinalMessages = (config) => {
    // This removes the review screen from the quizzes. 
    const { annotations } = config; 
    const annotationsNoMessages = annotations.filter(a => !a.toolType?.endsWith('Message'))
    return { 
        ...config,
        annotations: annotationsNoMessages
    }
}